var dependedOnViewportAd = require('src/interlock/product/ads/ad-manager/depended-on-viewport-ad.js');
var adContext = require('src/interlock/product/ads/ad-context/ad-context.js');

var _adIdToSlot = {};

function _init(adUnit) {
    var slot = window.googletag.defineSlot(
        adContext.getCommonContext().siteName,
        adUnit.currentSizes(),
        adUnit.getContainerId());
    if(slot){
        slot.addService(window.googletag.pubads());
        var targeting = adUnit.getTargetingValues();
        dependedOnViewportAd.addToViewPortAds(adUnit);
        for(var key in targeting) {
            slot.setTargeting(key, targeting[key]);
        }
        // TODO:  subscribe to renderEnd and broadcast event
        // googletag.pubads().addEventListener('slotRenderEnded', function (event) {
        //     console.log('Slot has been rendered:');
        //     console.log(event, adUnit.getId(), adUnit.getContainerId());// do not expose slot or adUnit!!!!!
        // });


        var  customTargetingValues = adUnit.getCustomTargetingValues();
        for(var i in customTargetingValues) {
            window.googletag.pubads().setTargeting(i, customTargetingValues[i]);
        }

        var moduleValue = adUnit.getModuleValue();
        setModuleTargeting(moduleValue);
        _adIdToSlot[adUnit.getId()] = {
            googleSlot: slot,
            customTargetingValues: customTargetingValues,
            moduleValue: moduleValue
        };



        adUnit.setRendered();
        return slot;
    }
}

function setModuleTargeting(moduleValue) {
    if(moduleValue) {
        window.googletag.pubads().setTargeting('module', moduleValue);
    }
}

function _getAdIdToSlot () {
    return _adIdToSlot;
}

module.exports = {
    init: _init,
    getAdIdToSlot: _getAdIdToSlot
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-manager/gpt-slot-initer.js
// module id = 122
// module chunks = 36